// extracted by mini-css-extract-plugin
module.exports = {"info":"info_info__AC381","info__icon":"info_info__icon__Y4OWV","info__error":"info_info__error__RGfdb"};